import React from 'react'
import SpinnerLoading from '@components/V3/loadingIndicators/Spinner'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import {useTranslation} from 'next-i18next'

export default function InReview() {
  const {t} = useTranslation('tracking', {keyPrefix: 'inReview'})
  const status = useStatus()
  if (status !== 'inReview') return null

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <SpinnerLoading size="lg" />
    </div>
  )
}
